import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { countriesAll } from "./countryCodes";
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import i18n from '../../helpers/i18n';
import { CountryType } from './countryCodes';


const CustomAutocomplete = styled(Autocomplete)({
    '& .MuiAutocomplete-inputRoot': {
      backgroundColor: 'white', // Change background color
      height: '30px', // Set specific height
      fontSize:"7pt"
    }
  });

export const countries = countriesAll.filter(country => country.language !== undefined);
export const countriesNonUS = countriesAll.filter(country => country.language !== undefined && country.language != 'en');


const LanguageSelector = ()=>{
    // reduce to only lanugages we support
    const [value, setValue] = React.useState<object | null>(countries[1]);
    const [inputValue, setInputValue] = React.useState('');

    return (
        <CustomAutocomplete
          id="country-select-demo"
          value={value}
          onChange={(event: any, newValue: any) => {
            console.log(newValue.language)
            setValue(newValue);
            i18n.changeLanguage(newValue.language);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          sx={{ width: 200}}
          options={countries}
          autoHighlight
          getOptionLabel={(option:any) => option.label}
          renderOption={(props, option:any) => (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              {option.label} ({option.language})
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose a country"
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
            />
          )}
        />
      );}


export default LanguageSelector

